import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/navigation/Navbar";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import { Box } from "@mui/system";
import NotFound from "./pages/NotFound";
// import Dashboard from './pages/Dashboard';
import AboutPage from "./pages/AboutPage";
import MailFlowLogs from "./pages/MailFlowLogs";
import MailReCall from "./pages/MailReCall";
import "./App.css";
import { ThemeProvider } from "./theme/themeContext";
import { SnackbarProvider } from "./context/snackbarContext";
import { Provider as JotaiProvider } from "jotai";
import { adminStore } from "./atoms/store";

const App = () => {
  return (
    <ThemeProvider>
      <JotaiProvider store={adminStore}>
        <SnackbarProvider>
          <Router>
            <Navbar />
            <Box mt={10} />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              {/* <Route path="/dashboard" element={<Dashboard />} /> */}
              <Route path="/about" element={<AboutPage />} />
              <Route path="/logs/email-flow" element={<MailFlowLogs />} />
              <Route path="/email/recall" element={<MailReCall />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </SnackbarProvider>
      </JotaiProvider>
    </ThemeProvider>
  );
};

export default App;
